import type { IconSvgObject } from './types';

const MeetingRoomIcon: IconSvgObject = [
  ["path", { d: "M17 21.0001V5C17 3.89543 16.1046 3 15 3H5C3.89543 3 3 3.89543 3 5V21L17 21.0001Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 6H19C20.1046 6 21 6.89543 21 8V20.9999H14.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13 11V13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default MeetingRoomIcon;
